export class JsonPathSample {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "sampleValue",
            "baseName": "sampleValue",
            "type": "string",
            "format": ""
        },
        {
            "name": "isString",
            "baseName": "isString",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JsonPathSample.attributeTypeMap;
    }
    constructor() {
    }
}
